var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 5.5C42.5 2.75 40.25 0.5 37.5 0.5H32.5C31.125 0.5 30 1.625 30 3C30 4.375 31.125 5.5 32.5 5.5H37.5V12.125L28.8 23H20V13C20 11.625 18.875 10.5 17.5 10.5H10C4.475 10.5 0 14.975 0 20.5V25.5C0 26.875 1.125 28 2.5 28H5C5 32.15 8.35 35.5 12.5 35.5C16.65 35.5 20 32.15 20 28H28.8C30.325 28 31.75 27.3 32.7 26.125L41.4 15.25C42.125 14.35 42.5 13.25 42.5 12.125V5.5ZM12.5 30.5C11.125 30.5 10 29.375 10 28H15C15 29.375 13.875 30.5 12.5 30.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3H17.5C18.875 3 20 4.125 20 5.5C20 6.875 18.875 8 17.5 8H10C8.625 8 7.5 6.875 7.5 5.5C7.5 4.125 8.625 3 10 3ZM42.5 20.5C38.35 20.5 35 23.85 35 28C35 32.15 38.35 35.5 42.5 35.5C46.65 35.5 50 32.15 50 28C50 23.85 46.65 20.5 42.5 20.5ZM42.5 30.5C41.125 30.5 40 29.375 40 28C40 26.625 41.125 25.5 42.5 25.5C43.875 25.5 45 26.625 45 28C45 29.375 43.875 30.5 42.5 30.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/DeliveryIcon.6dd070515464b6ebd86d46329ec9686c.svg";
export { ForwardRef as ReactComponent };